/*
 * @Author: Ashley.Liu
 * @Date: 2022-06-28 13:44:13
 * @LastEditTime: 2022-12-08 13:19:26
 * @Description: desc
 */
import {
  Button,
  Locale,
  Dropdown,
  Breadcrumb,
  Menu,
  Row,
  Table,
  Tabs,
  Input,
  Form,
  Loading,
  Dialog,
  Message,
  Pagination,
  MessageBox,
  Popover,
  InputNumber,
  CheckboxGroup,
  Checkbox,
  Select,
  Tag,
  Tree,
  Switch,
  Radio,
  RadioGroup,
  DatePicker,
  TimePicker,
  Col,
  Scrollbar,
  Avatar,
  Autocomplete,
  FlexInput,
  Steps,
  Drawer,
  Upload,
  Alert,
  Icon,
  HighlightText,
  Collapse,
  ButtonGroup,
  Skeleton,
  MultiSelect,
  Progress,
  GroupSelect,
  /* eslint-disable no-unused-vars */
  Style
} from '@zoom/zoom-ui'

import Vue from 'vue'
import AsyncUi from '@zoom/async-ui'

Vue.use(Button)
Vue.use(Locale)
Vue.use(Dropdown)
Vue.use(Breadcrumb)
Vue.use(Menu)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Input)
Vue.use(Form)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(Message)
Vue.use(Pagination)
Vue.use(MessageBox)
Vue.use(Popover)
Vue.use(InputNumber)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Switch)
Vue.use(Tree)
Vue.use(RadioGroup)
Vue.use(Scrollbar)
Vue.use(Avatar)
Vue.use(Autocomplete)
Vue.use(FlexInput)
Vue.use(Steps)
Vue.use(Drawer)
Vue.use(Upload)
Vue.use(Alert)
Vue.use(Icon)
Vue.use(HighlightText)
Vue.use(Collapse)
Vue.use(AsyncUi)
Vue.use(Collapse)
Vue.use(ButtonGroup)
Vue.use(Skeleton)
Vue.use(MultiSelect)
Vue.use(Progress)
Vue.use(GroupSelect)
